import {
    apiRequest,
    List,
    ListPPI,
    ListDetail,
    ListPegawai,
    ListUnitKerja,
    ListJabatan,
    Inactive,
    InactiveDetail,
    Detail,
    DetailMutasi,
    masterRegion,
    UpdateTMTEnd,
    UploadDecree
} from "../../../../../services/adapters/kepegawaian/mutasiPegawaiService"

class IndexRepository {

    fetchList = async (query, cancelToken) => {
        return await apiRequest("get", ListPPI, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchListDetail = async (query, cancelToken) => {
        return await apiRequest("get", ListDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchListPegawai = async (query, cancelToken) => {
        return await apiRequest("get", ListPegawai, {
            cancelToken: cancelToken,
            params: query,
        }, true)
    }

    fetchListUnitKerja = async (query, cancelToken) => {
        return await apiRequest("get", ListUnitKerja, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchListJabatan = async (query, cancelToken) => {
        return await apiRequest("get", ListJabatan, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", Inactive, {
            body: query,
        }, true)
    }

    fetchInactiveDetail = async (query) => {
        return await apiRequest("post", InactiveDetail, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", Detail, {
            params: query,
        })
    }

    fetchDetailMutasi = async (query) => {
        return await apiRequest("get", DetailMutasi, {
            params: query,
        })
    }

    fetchRegion = async (query, cancelToken) => {
        return await apiRequest("get", masterRegion, {
            cancelToken: cancelToken,
            params: query
        }, true);
    }

    fetchTMTEnd = async (query, cancelToken) => {
        return await apiRequest("post", UpdateTMTEnd, {
            body: query
        }, true)
    }

    ftechUploadDecree = async (query, cancelToken) => {
        return await apiRequest("post", UploadDecree, {
            body: query
        }, true)
    }

}

export default IndexRepository;